import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
  Button,
  makeStyles,
} from '@material-ui/core';
import { classnames } from 'classnames';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSWR from 'swr';
import { getProviderById, updateProviderAffiliateSetting } from '../../../api/cms/provider';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGlow: 1,
  },
  img: {
    width: '100%',
    height: 'auto',
    maxWidth: '200px',
  },
  cursor: {
    cursor: 'pointer',
  },
  saveButton: {
    marginTop: theme.spacing(2),
  },
}));

import DialogImageBox from '../../../components/ImageBox';

const ProviderImageCategory = ({ data = [] }) => {
  const { providerId } = useParams();
  const [imageUpdates, setImageUpdates] = useState({});
  const classes = useStyles();

  const { data: providerInfo } = useSWR(
    ['providerById', providerId],
    (url, providerId) => getProviderById(providerId),
    { revalidateOnFocus: false, refreshInterval: 0, shouldRetryOnError: false },
  );

  const affiliateSettings = providerInfo?.affiliate_settings || data;

  const onChangeValueHandler = (categoryCode, val) => {
    setImageUpdates((prev) => ({
      ...prev,
      [categoryCode]: { ...prev[categoryCode], file: val },
    }));
  };

  const onImageChangeHandler = (categoryCode, val) => {
    console.log('provider_logo val: ', val);
    setImageUpdates((prev) => ({
      ...prev,
      [categoryCode]: { ...prev[categoryCode], image: val },
    }));
  };

  const handleSave = async () => {
    if (Object.keys(imageUpdates).length === 0) {
      toast.warning('No image selected');
      return;
    }

    try {
      for (const affiliate of affiliateSettings) {
        const updatedImage = imageUpdates[affiliate.category]?.image;
        if (updatedImage) {
          const payload = {
            provider_affiliates: {
              category_code: affiliate.category,
              enabled: affiliate.enabled,
              logo: updatedImage,
            },
          };
          await updateProviderAffiliateSetting(providerId, payload);
        }
      }
      toast.success('Images updated successfully');
      setImageUpdates({});
    } catch (error) {
      console.error('Error updating provider:', error);
      toast.error('Failed to update images');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom component="div">
        Image Settings
      </Typography>
      <TableContainer component={Paper}>
        <Table aria-label="image provider by category" size="small">
          <TableBody>
            {affiliateSettings.length > 0 ? (
              affiliateSettings.map((v, i) => {
                const displayCategory = v.category;
                return (
                  <TableRow key={i}>
                    <TableCell>{displayCategory.toUpperCase()}</TableCell>
                    <TableCell>
                      <DialogImageBox
                        image={v.logo}
                        onChangeValue={(val) => onChangeValueHandler(v.category, val)}
                        onImageChange={(val) => onImageChangeHandler(v.category, val)}
                      />
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell>Not Found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          className={classes.saveButton}
          onClick={handleSave}
          disabled={Object.keys(imageUpdates).length === 0}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default ProviderImageCategory;
